import {
  Tier,
  TierId,
  tierList,
  tierMap,
  TIERS,
} from 'structure/launchpad/constants/tiers';

export function getTierBySrep(srep: number): Tier {
  for (let i = 0; i <= tierList.length - 1; i++) {
    const tier = tierList[i];

    const isLastTier = i === tierList.length - 1;
    if (isLastTier) {
      return tier;
    }

    const nextTier = tierList[i + 1];

    const isSREPBetweenCurrentAndNextTier =
      srep >= tier.srep && srep < nextTier.srep;
    if (isSREPBetweenCurrentAndNextTier) {
      return tier;
    }
  }

  return getTierById(TIERS.NO_TIER);
}

export function getNextTierBySrep(srep: number): Tier | null {
  const tier = getTierBySrep(srep);
  const tierIndex = tierList.findIndex((item) => item.id === tier.id);

  if (tierIndex === tierList.length - 1) {
    return null;
  }

  return tierList[tierIndex + 1];
}

export function getTierById(tierId: TierId): Tier {
  return tierMap[tierId];
}

export const getGreaterTier = (tierIds: TierId[]) => {
  const tiers = tierIds.map((tierId) => tierMap[tierId]);
  return tiers.reduce((acc, tier) => {
    if (tier.srep > acc.srep) {
      return tier;
    }
    return acc;
  }, getTierById(TIERS.NO_TIER));
};

export function removeExtraSlashes(str: string): string {
  const protocolMatch = str.match(/^(https?:\/\/)/);
  const protocol = protocolMatch ? protocolMatch[0] : '';
  const urlWithoutProtocol = str.replace(/^(https?:\/\/)/, '');
  const cleanedUrl = urlWithoutProtocol.replace(/\/{2,}/g, '/');
  return protocol + cleanedUrl;
}
